import React from 'react'
import Helmet from 'react-helmet'

const jsonData = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name:
        'What is the cost of creating a matrimonial profile on BengaliShaadi.com?',
      acceptedAnswer: {
        '@type': 'Answer',
        text:
          'Registration is absolutely free. To enjoy additional benefits, you can choose any of the below premium membership plans. To know more about these plans, click here Gold 3 Months Connect directly with Matches View detailed Profile information Gold Plus 3 Months Connect directly with Matches View detailed Profile information Be featured under Spotlight Standout with Bold Listing Diamond6 Months Connect directly with Matches View detailed Profile information Top Seller Diamod Plus 6 Months Connect directly with Matches View detailed Profile information Be featured under Spotlight Standout with Bold Listing Platinum Plus 12 Months Connect directly with Matches View detailed Profile information Be featured under Spotlight Standout with Bold Listing',
      },
    },
    {
      '@type': 'Question',
      name: 'What is a Profile ID? How is it relevant?',
      acceptedAnswer: {
        '@type': 'Answer',
        text:
          'Your Profile ID is automatically generated once you register on BengaliShaadi.com. Every Member has a unique Profile ID and Members can find your Profile using the Profile ID search feature.',
      },
    },
    {
      '@type': 'Question',
      name: 'What are the safety measures on BengaliShaadi.com?',
      acceptedAnswer: {
        '@type': 'Answer',
        text:
          'We are committed to your safety &amp; privacy and have taken the below measures to bring you a safe matchmaking experience:Privacy settings Photo privacy allows you to control who can view your photos Display Name settings let you maintain anonymity at all times Phone number settings let you decide who can see your number Profile Screening: Every profile on BengaliShaadi.com is screened to make your experience safe and secure. In the rare case that you come across some misuse on the platform, simply select the ‘Report’ option on the top right of the suspicious profile. Alternatively you can write to us at help@shaadi.com Shaadi Chat allows you to have conversations with your matches without sharing your phone number',
      },
    },
    {
      '@type': 'Question',
      name: 'What are the steps to register myself on BengaliShaadi.com?',
      acceptedAnswer: {
        '@type': 'Answer',
        text:
          "Go to www.bengalishaadi.com or download the BengaliShaadi.com app Fill out the required information in the Registration Form and click on the 'Submit' button. The more information you provide about yourself, the more likely you are to be contacted by other Members of BengaliShaadi.com. So please do take the time and effort to complete your Profile",
      },
    },
    {
      '@type': 'Question',
      name: 'How do I view my matrimony profile on BengaliShaadi.com?',
      acceptedAnswer: {
        '@type': 'Answer',
        text:
          'Login using your Email ID and Password. Click on ‘My Profile’ to see your profile as others see it.',
      },
    },
    {
      '@type': 'Question',
      name:
        'Can I specify more than one email while registering on BengaliShaadi.com?',
      acceptedAnswer: {
        '@type': 'Answer',
        text:
          'No. You may specify only one email while registering. You can however change your email address later if you wish.',
      },
    },
    {
      '@type': 'Question',
      name:
        'Can I create a matrimony profile on behalf of a relative or a friend?',
      acceptedAnswer: {
        '@type': 'Answer',
        text:
          'Yes you can! In the registration form, you can specify your relationship with the person on whose behalf you are registering.',
      },
    },
    {
      '@type': 'Question',
      name: 'What are the benefits of registering on BengaliShaadi.com?',
      acceptedAnswer: {
        '@type': 'Answer',
        text:
          'You can avail of the following services as a free Member:-Create and manage your Profile on BengaliShaadi.com Search and View Matches Shortlist Members that you like Send invitations to your matches and accept invitations that you have received See Members who visited your Profile, Members who joined recently and Members who match your Partner Preferences.',
      },
    },
    {
      '@type': 'Question',
      name:
        'My Religion/Caste/Profession is not listed as an option in the registration form. What should I do?',
      acceptedAnswer: {
        '@type': 'Answer',
        text:
          "BengaliShaadi.com has tried to be as comprehensive as possible while creating the many lists being used in the registration form. However, it is possible that your particular religion / caste, education, profession etc may not be represented here.In such a case we request that you use the 'Other' option provided to you. Also, you can send an email to customercare@shaadi.com clearly listing the new addition you would like us to make to the registration form. While we do not guarantee that your suggestion will be accepted, we will try our best to ensure that it does.",
      },
    },
    {
      '@type': 'Question',
      name:
        'What is the advantage of verifying my phone number? How can I do it?',
      acceptedAnswer: {
        '@type': 'Answer',
        text:
          'Verifying your phone number helps you get more responses, since it earns you a trust badge. The trust badge is displayed on the top right of your profile and adds authenticity to it.You can verify your phone number by using either our Interactive Voice Response System or via SMS in case you have provided a mobile number as your contact number.',
      },
    },
  ],
}

const JsonLd = () => (
  <Helmet>
    <script type="application/ld+json">{JSON.stringify(jsonData)}</script>
  </Helmet>
)

export default JsonLd
